import { v4 as uuidv4 } from 'uuid';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { updatePublicAPI } from '@/service/publicService';

/**
 * Create temporary file objects from files
 * @param {File[]} files - List of files
 * @returns {Object[]} - List of file objects with id, fileName, fileData, fileExtension, fileSize, uploadStatus
 */
const createTmpFileObjects = (files) => {
    return files.map(file => {
        const dotIndex = file.name.lastIndexOf('.');
        const fileExtension = dotIndex > 0 ? file.name.substring(dotIndex + 1).toLowerCase() : '';
        return {
            id: `tmp_file_${uuidv4()}`,
            fileName: file.name,
            fileData: file,
            fileExtension: fileExtension,
            fileSize: file.size,
            uploadStatus: Constant.AI_CHAT_UPLOAD_STATUS.UPLOADING
        };
    });
};

/**
 * Get truncated file name (max 15 characters)
 * @param {string} fileName - Original file name
 * @returns {string} - Truncated file name
 */
const getTruncatedFileName = (fileName) => {
    if (!fileName) return '';
    const dotIndex = fileName.lastIndexOf('.');
    const nameWithoutExt = dotIndex > 0 ? fileName.substring(0, dotIndex) : fileName;
    const extension = dotIndex > 0 ? fileName.substring(dotIndex) : '';

    if (nameWithoutExt.length <= 15) {
        return fileName;
    }
    return `${nameWithoutExt.substring(0, 15)}...${extension}`;
};

/**
 * Remove uploaded file
 * @param {Object} removeFile - File to remove
 * @param {Function} setUploadFiles - Set uploaded files function
 */
const removeUploadedFile = (removeFile, setUploadFiles) => {
    setUploadFiles(prevFiles => prevFiles.filter(file => file.id !== removeFile.id));
    if (removeFile.s3Path) {
        updatePublicAPI(null, {
            updateApiType: Constant.UPDATE_API_PUBLIC_TYPE.DELETE_S3_FILE_BY_PATH,
            s3Path: removeFile.s3Path
        });
    }
};

/**
 * Cleanup uploaded files
 * @param {Object[]} uploadFiles - List of uploaded files
 * @param {Function} setUploadFiles - Set uploaded files function
 */
const cleanupUploadedFiles = (uploadFiles, setUploadFiles) => {
    if (Utils.isEmptyArray(uploadFiles)) return;
    setUploadFiles([]);
};

export {
    createTmpFileObjects,
    getTruncatedFileName,
    removeUploadedFile,
    cleanupUploadedFiles
};
